<template>
  <footer>
    <h2>Cine House &copy;</h2>
  </footer>
</template>

<script>
export default {
  name: "FooterComponent",
};
</script>

<style lang="scss" scoped>
footer {
  height: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: black;
  color: white;
}
</style>
